/**
 * @ngdoc controller
 * @name MenuBarController
 * @description
 * This component renders the Menu Bar.
 *
 * @memberof rootModule
 */
class MenuBarController {
  /**
   * Class constructor
   * @param {Service} $location        Used to redirect user after the upload process finished.
   * @param {Object}  $rootScope       To broadcast the tracking events.
   * @param {Service} campaignsService To get the list of campaigns.
   * @param {Service} ccaSession       To get the current session.
   * @param {Service} errorHandler     To show any errors.
   * @param {Service} uploadQueue      We're going to need this to allow upload on this section.
   * @param {Object}  AUTH_EVENTS      The name of the events the method needs to listen for.
   * @param {Array}   MENU_ITEMS       Array of menu items.
   * @param {Object}  TRACKING_EVENTS  To get the name of the events to be broadcasted.
   * @ignore
   */
  constructor(
    $location,
    $rootScope,
    campaignsService,
    ccaSession,
    errorHandler,
    uploadQueue,
    AUTH_EVENTS,
    MENU_ITEMS,
    TRACKING_EVENTS,
  ) {
    'ngInject';

    /**
     * Local reference for the Location Service.
     * @type {Service}
     */
    this.$location = $location;
    /**
     * The local reference to the `$rootScope` object.
     * @type {Object}
     */
    this.$rootScope = $rootScope;
    /**
     * The local reference to the `campaignsService` service.
     * @type {Object}
     */
    this.campaignsService = campaignsService;
    /**
     * The local reference to the `ccaSession` service.
     * @type {Object}
     */
    this.ccaSession = ccaSession;
    /**
     * The local reference to the `errorHandler` service.
     * @type {Object}
     */
    this.errorHandler = errorHandler;
    /**
     * Local reference for the upload Queue Service.
     * @type {Service}
     */
    this.uploadQueue = uploadQueue;
    /**
     * The local reference to the `AUTH_EVENTS` constant.
     * @type {Object}
     */
    this.AUTH_EVENTS = AUTH_EVENTS;
    /**
     * The copy reference of the `MENU_ITEMS` constant.
     * @type {Object}
     */
    this.menu = angular.copy(MENU_ITEMS);
    /**
     * The local reference to the `TRACKING_EVENTS` constant.
     * @type {Object}
     */
    this.TRACKING_EVENTS = TRACKING_EVENTS;
    /**
     * Local reference if the user can upload media.
     * @type {Boolean}
     */
    this.canUploadMedia = false;
  }
  /**
   * Set the canUploadMedia flag and start to listen the authorization events.
   */
  $onInit() {
    if (this.ccaSession.isAccountSelected()) {
      this.campaignsService.load(true)
      .then((campaigns) => {
        this.canUploadMedia = campaigns.length > 0;
      });
    }

    this.removeCustomerChanged = this.$rootScope
    .$on(this.AUTH_EVENTS.customerChanged, () => {
      this.campaignsService.load(true)
      .then((campaigns) => {
        this.canUploadMedia = campaigns.length > 0;
      });
    });
  }
  /**
   * Each time the data binding changes, update the active menu accordingly.
   */
  $onChanges({ item }) {
    if (item && item.currentValue) {
      const activeItem = item.currentValue;
      this.menu.forEach((mI) => {
        mI.active = mI.title === activeItem.title;
      });
    }
  }
  /**
   * When this component gets destroyed, unsubscribe to all events in order to prevent memory
   * leaks.
   */
  $onDestroy() {
    this.removeCustomerChanged();
  }
  /**
   * Check if the media upload is possible and display an error if not.
   */
  checkIfCanUploadMedia() {
    if (!this.canUploadMedia) {
      this.errorHandler.showErrorMessage('Sorry, there is no campaign to upload content to.');
    }
  }
  /**
   * Add the FILE oject to the upload queue service.
   * @param {FileList} selectedFiles list of seleted files by the user.
   */
  fileSelected(selectedFiles) {
    this.uploadQueue.addItems(selectedFiles);
    this.$location.url('/upload');
  }
  /**
   * Track the click action on the menu item.
   * @param {String} item the item that was clicked.
   */
  trackClick(item) {
    this.$rootScope.$broadcast(this.TRACKING_EVENTS.navigation[`click${item}`]);
  }
}

export default MenuBarController;



// WEBPACK FOOTER //
// ./src/frontend/modules/root/components/menuBar/menuBar.controller.js